import DocumentCard from "../../../../documents/DocumentCard";
import { Col, Row } from "react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faUnlink } from "@fortawesome/free-solid-svg-icons";
import { btn, btnHoverStyle } from "../../../../../../layout/Buttons/buttonStyles";
import DocumentsOverview from "./SubTabs/Documents/DocumentsOverview";
import listHandler from "@serie3/common/Domain/listHandler";

const Files = ({ documents, projectFormik }) => {
  const [showForm, setShowForm] = useState(false);

  const AddButton = () => (
    <>
      <style>{btnHoverStyle}</style>
      <button
        className="btn-modern"
        style={{ ...btn.base, ...btn.success }}
        onClick={() => setShowForm(true)}
      >
        <FontAwesomeIcon icon={faAdd} /> Add
      </button>
    </>
  );

  const CardButtons = ({document}) => (
    <button
      className="btn-modern"
      style={{ ...btn.base, ...btn.icon, ...btn.iconSoft("#ffebee", "#c62828") }}
      onClick={() => {
        listHandler.deleteWithoutCall(document, projectFormik.values["documents"]);
        projectFormik.handleSubmit();
      }}
    >
      <FontAwesomeIcon icon={faUnlink} />
    </button>
  );

  return (
    <>
      <DocumentsOverview
        show={showForm}
        setShow={setShowForm}
        projectFormik={projectFormik}
      />
      <Row>
        <Col className="text-end">
          <AddButton />
        </Col>
      </Row>
      <br />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "16px" }}>
        {documents
          ? documents.map((document) => (
              <DocumentCard
                key={document.id}
                document={document}
                CardButtons={() => <CardButtons document={document} />}
              />
            ))
          : null}
      </div>
    </>
  );
};
export default Files;
